<template>
    <v-navigation-drawer app v-model="openedDrawer" class="grey darken-4">
        <v-list dense flat nav dark>
            <v-list-item class="pa-2 mb-2">
                <v-img
                    :src="
                        resellerLogo ||
                            require('@/assets/img/connectplug-logo-azul.png')
                    "
                    max-height="40px"
                    contain
                ></v-img>
            </v-list-item>

            <v-divider class="grey darken-2"></v-divider>

            <v-list-item>
                <v-list-item-avatar>
                    <v-img
                        :src="
                            resellerFavicon ||
                                require('@/assets/img/default-logo.png')
                        "
                    ></v-img>
                </v-list-item-avatar>

                <v-list-item-title>{{
                    $store.getters['reseller/name']
                }}</v-list-item-title>
            </v-list-item>

            <v-divider class="grey darken-2"></v-divider>

            <div v-for="(link, index) in links" :key="index">
                <v-list-item
                    v-if="!link.children"
                    active-class="blue--text text--lighten-4"
                    :to="link.path"
                    :href="link.href"
                    target="__blank"
                >
                    <v-list-item-action>
                        <v-icon>{{ link.icon }}</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title
                            v-text="$t(`drawer.texts.${link.name}`)"
                        ></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group
                    v-else
                    :prepend-icon="link.icon"
                    color="none"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="$t(`drawer.texts.${link.name}`)"
                            ></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item
                        v-for="(item, i) in link.children"
                        :key="i"
                        active-class="blue--text text--lighten-4"
                        :to="item.path"
                        :href="item.href"
                        target="__blank"
                        link
                    >
                        <v-list-item-content>
                            <v-list-item-title v-on:click="handleClick(item)">
                                {{ $t(`drawer.texts.${item.name}`) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </div>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import drawerLinks from './DrawerLinks'

export default {
    props: ['drawer'],

    data: () => {
        return {
            openedDrawer: null,
        }
    },

    methods: {
        async handleClick(item) {
            if (typeof item.mutator !== 'undefined') {
                this.$store.commit(item.mutator)
            }

            if (typeof item.handle !== 'undefined') {
                await item.handle(item)
            }
        },
    },

    watch: {
        drawer(value) {
            this.openedDrawer = value
        },

        openedDrawer(value) {
            this.$emit('change', value)
        },
    },

    computed: {
        resellerFavicon() {
            let reseller = this.$store.getters['reseller/reseller']
            if (reseller.id && reseller.brand.favicon)
                return reseller.brand.favicon_url
            return null
        },

        resellerLogo() {
            let reseller = this.$store.getters['reseller/reseller']
            if (reseller.id && reseller.brand.logo)
                return reseller.brand.logo_url
            return null
        },

        links() {
            let show = function(permission) {
                if (!permission) {
                    return true
                }

                return this.$store.getters[permission] || this.can(permission)
            }.bind(this)

            return drawerLinks.filter(link => {
                let showParent = show(link.permission)

                if (link.children && showParent) {
                    link.children = link.children.filter(child => {
                        return show(child.permission)
                    })
                }

                return showParent
            })
        },
    },

    created() {
        this.openedDrawer = this.drawer
    },
}
</script>
